import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Collapse,
  Divider,
  List,
  ListItemButton,
  Stack,
  TextField,
  Typography,
  Zoom,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useFormik } from "formik";
import { useState } from "react";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { Add } from "@mui/icons-material";

function Notify() {
  
const note = [
  {id:1, title:'Settings', body:'Update your subscription'}
]
  const [notices, setNotices] = useState(note);
 

  return (
    <Zoom in={true} style={{ transitionDelay: "200ms" }}>
      <Stack display={"flex"} justifyContent={"center"}>
        <Card>
          <CardHeader title={<Typography>Notifications</Typography>} />
          <CardContent
            sx={{ display: "flex", flexDirection: "column", rowGap: 2 }}
          >
            <Stack
              display={"flex"}
              justifyContent={"center"}
              rowGap={2}
            >
              <List>
                {notices?
                
                  notices.map(notice=>{
                    <ListItemButton sx={{bgcolor:'warning'}} key={notice.id}>
                    <Box display={'flex'} justifyContent={'space-between'}>
                      <Typography variant="body1" fontWeight={'bold'}>{notice.title}</Typography>
                      <Divider/>
                      <Typography variant="body2" >{notice.body}</Typography>

                      <Add/>
                    </Box>
                  </ListItemButton>
                  }):<Typography variant="body1" fontWeight={'bold'}>No notifications</Typography>
              }
              </List>
            </Stack>
          </CardContent>
        </Card>
      </Stack>
    </Zoom>
  );
}

export default Notify;
